import { render } from "./MyPublicationSubscriptions.vue.js?vue&type=template&id=ad17c0f2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationSubscriptions.vue?vue&type=template&id=ad17c0f2"
import script from "./MyPublicationSubscriptions.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationSubscriptions.vue?vue&type=script&lang=js"
export * from "./MyPublicationSubscriptions.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationSubscriptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/MyPublicationSubscriptions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad17c0f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad17c0f2', __exports__)) {
    api.reload('ad17c0f2', __exports__)
  }
  
  module.hot.accept("./MyPublicationSubscriptions.vue.js?vue&type=template&id=ad17c0f2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationSubscriptions.vue?vue&type=template&id=ad17c0f2", () => {
    api.rerender('ad17c0f2', render)
  })

}


export default __exports__